import React from "react";
import './assessment-engine.scss';
import Loading from "../loading/loading";
import AssessmentHeader from "../assessment-header/assessment-header";
import AssessmentEngineShared from "../../../../shared-storage/assessment-engine";
import SharedProfile from "../../../../shared-storage/profile";
import AssessmentApi from "../../../apis/assessment";
import SharedThemeCategory from "../../../../shared-storage/category-theme";
import AssessmentPagination from "../assessment-pagination/assessment-pagination";
import Question from "../question/question";
import FlagPopup from "../flag-popup/flag-popup";
import AssessmentEndPopup from "../assessment-end-popup/assessment-end-popup";
import { Constants, FirebaseEvents } from "../../../constants/constants";
import { MyAssessmentContext } from "../my-assessment-context/my-assessment-content";
import HomeworkApi from "../../../apis/homework";
import FireBaseEvent from '../../../firebase-events/firebase-events';
import CommonUtils from "../../../utility/common-utilities";
import CorrectIncorrectAnswerModel from "../correct-incorrect-answer-modal/correct-incorrect-answer-modal";
import AuthenticateAPI from "../../../apis/authenticate";
// export const MyAssessmentContext = React.createContext({
//     showFinishFooter: false,
//     isAssessment: false,
//     disableNext: false
// })


let onlyonce = false;


class AssessmentEngine extends React.Component {

    constructor(props) {
        super(props);

        AssessmentEngineShared.setAssessmentEngine(this)

        this.userInfo = SharedProfile.getProfile();

        this.meta = this.props.meta

        this.chapterKey = this.meta.chapterKey;
        this.questionSetId = this.meta.questionSetId;
        this.chapterTitle = this.meta.chapterTitle
        this.categoryThemeId = this.meta.categoryThemeId;

        console.log(this.meta)

        if (this.meta.selectedChapters) {

            //console.log('::::::selected chapters', this.meta.selectedChapters)

            for (let i = 0; i < this.meta.selectedChapters.length; i++) {
                this.selectedChaptersHash[this.meta.selectedChapters[i].key] = this.meta.selectedChapters[i]
            }
        }

        console.log(this.meta)

        if (this.meta.isResume && this.meta.assessmentActivityId) {

            if (this.meta && (this.meta.from == Constants.EVENT_BASELINE || this.meta.from == Constants.REWARD_EVENT_BASELINE || this.meta.from == Constants.TWO_STEP_EVENT_BASELINE)) {

                // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

                // if (!this.userInfo.isSubscribed)
                //     this.landingScreenInstance.pauseUserAppTime()

            }

            if (this.meta && this.meta.from == Constants.SCHOLARSHIP_EVENT || this.meta.from == Constants.REWARD_EVENT_FINAL || this.meta.from == Constants.TWO_STEP_EVENT_FINAL) {
                // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

                // if (!this.userInfo.isSubscribed)
                //     this.landingScreenInstance.pauseUserAppTime()
            }

            this.assessmentActivityId = this.meta.assessmentActivityId

            let payload = {
                assessmentActivityId: this.assessmentActivityId,
                isResume: true
            }

            this.getAssessement(payload)
        } else {

            // if(onlyonce) return
            // onlyonce = true

            let payload = {
                chapterKey: this.chapterKey,
                questionSetId: this.questionSetId
            }

            if (this.meta.selectedDuration) {
                payload['duration'] = this.meta.selectedDuration
            }

            if (this.meta.type == 'EVENT') {
                payload.type = 'EVENT'
                payload.assessmentId = this.meta.assessmentId;
            }

            if (this.meta && this.meta.from == Constants.REFRESHER_COURSE) {
                payload.type = Constants.REFRESHER_COURSE
            }

            if (this.meta && this.meta.from == Constants.SCHOLARSHIP_MAY_9_2021) {
                payload.type = Constants.SCHOLARSHIP_MAY_9_2021
            }

            if (this.meta && (this.meta.from == Constants.EVENT_BASELINE || this.meta.from == Constants.REWARD_EVENT_BASELINE || this.meta.from == Constants.TWO_STEP_EVENT_BASELINE)) {
                payload.type = Constants.EVENT_BASELINE
                payload.eventId = this.meta.eventId

                // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

                // if (!this.userInfo.isSubscribed)
                //     this.landingScreenInstance.pauseUserAppTime()
            }

            if (this.meta && this.meta.from == Constants.SCHOLARSHIP_EVENT || this.meta.from == Constants.REWARD_EVENT_FINAL || this.meta.from == Constants.TWO_STEP_EVENT_FINAL) {
                payload.type = Constants.SCHOLARSHIP_EVENT
                payload.eventId = this.meta.eventId

                // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

                // if (!this.userInfo.isSubscribed)
                //     this.landingScreenInstance.pauseUserAppTime()
            }

            if (this.meta && this.meta.from == Constants.MPL_EVENT) {
                payload.type = Constants.MPL_EVENT
                payload.assessmentId = this.meta.assessmentId;
                payload.eventId = this.meta.eventId
            }

            if (this.meta && this.meta.isFromMyHomework) {
                payload.isFromMyHomework = true
                payload.homeworkActivityId = this.meta.homeworkActivityId
            }

            if (this.meta && this.meta.from && this.meta.from == "MOCK_TEST") {
                payload.type = "MOCK_TEST"
                payload.assessmentId = this.meta.assessmentId;
                payload.eventId = this.meta.eventId
            }

            if (this.meta && this.meta.isFromPracticeCaseStudy) {
                payload.isFromPracticeCaseStudy = true
                payload.practiceActivityId = this.meta.practiceActivityId
            }

            if (this.meta && this.meta.from == 'CLASS_MOCK_TEST') {
                payload.type = 'CLASS_MOCK_TEST'
            }

            if (this.meta && this.meta.from == 'SELECTED_CHAPTER_MOCK_TEST') {
                payload.type = 'SELECTED_CHAPTER_MOCK_TEST'
                payload.chapterTitle = this.meta.chapterTitle
            }


            if (this.meta && this.meta.from == 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST') {
                payload.type = 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST'
            }



            if (this.meta && this.meta.from == 'SCIENCE_CLASS_MOCK_TEST') {
                payload.type = 'SCIENCE_CLASS_MOCK_TEST'
            }

            if (this.meta.chapterTitle) {
                payload.chapterTitle = this.meta.chapterTitle
            }



            //console.log("Called")
            this.getAssessement(payload, true)
        }

    }


    state = {
        questions: [],
        showSlowInternetPopup: false,
        // questions: [
        //     // {
        //     //     "id": "618222ff2f081330c715fc12"
        //     // },
        //     // {
        //     //     "id": "618223902f081330c715fc16"
        //     // },
        //     // {
        //     //     "id": "618225092f081330c715fc1a"
        //     // },
        //     // {
        //     //     "id": "618225612f081330c715fc1d"
        //     // },
        //     // {
        //     //     "id": "618225c12f081330c715fc20"
        //     // },
        //     // {
        //     //     "id": "618226332f081330c715fc23"
        //     // },
        //     // {
        //     //     "id": "6182269f2f081330c715fc26"
        //     // },
        //     // {
        //     //     "id": "618227302f081330c715fc29"
        //     // },
        //     // {
        //     //     "id": "618227a52f081330c715fc2c"
        //     // },
        //     // {
        //     //     "id": "618228272f081330c715fc2f"
        //     // },
        //     // {
        //     //     "id": "6182326a2f081330c715fc3c"
        //     // },
        //     // {
        //     //     "id": "6182337a2f081330c715fc3f"
        //     // },
        //     // {
        //     //     "id": "618235032f081330c715fc42"
        //     // }
        // ],
        index: 0,
        showFlagPopUp: false,
        showAssessEndPopUp: false,
        remainingTime: 0,
        showTimeUpPopUp: false,
        isFlaggedContentRendering: false,
        currentFlaggedIndex: 0,
        showFinishFooter: false,
        isAssessment: true,
        stepIndex: 0,
        questionDetailsHash: {},
        disableNext: false,
        loading: false,
        currentTime: 0,
        attachments: {},
        questionLoading: true,
        isDesktop: window.innerWidth > 991
    };

    flaggedContents = []

    CONTENT_FETCH_LIMIT = 1;
    selectedChaptersHash = {}

    currentTime = 0

    componentDidMount() {

        setTimeout(() => {
            this.setState({ loading: true }, () => {
                this.setState({ loading: false })
            })
        }, 100)
        window.addEventListener('resize', this.updatePredicate);

        if (this.userInfo?.isElectron && window.electron?.onAppBlur) {
            const homeworkId = (this.meta && this.meta.homework && this.meta.homework.homeworkId) ? this.meta.homework.homeworkId : null;
            
            setTimeout(() => {
                this.isReadyForBlur = true;
            }, 500);

            this.removeBlurListener = window.electron.onAppBlur(() => {
                if (!this.isReadyForBlur) return;

                AuthenticateAPI.studentLogout({
                    isElectron: this.userInfo.isElectron,
                    homeworkId: homeworkId,
                    status: "LOGOUT",
                    time: new Date()
                }).then(() => {
                    SharedProfile.setProfile({ isAuthenticated: false });
                    window.location.reload();
                }).catch(() => {
                    SharedProfile.setProfile({ isAuthenticated: false });
                    window.location.reload();
                });
            });
        }
    }

    componentWillUnmount() {
        this.isReadyForBlur = false;
        window.removeEventListener('resize', this.updatePredicate);
        if (typeof this.removeBlurListener === 'function') {
            this.removeBlurListener();
            this.removeBlurListener = null;
        }
    }

    updatePredicate = () => {
        this.setState({ isDesktop: window.innerWidth > 991 });
    }

    showSlowInternetMessageAndStayOnTheSameQuestion() {
        this.setState({ showSlowInternetPopup: true });
    }

    hideSlowInternetPopup() {
        // console.log(this.answer)
        this.setState({ showSlowInternetPopup: false, disableNext: false });
    }



    getAssessement = (payload, assessmentStart) => {
        //console.log(assessmentStart)
        payload = payload ? payload : {}

        AssessmentApi.getMyAssessmentContent(payload).then((res) => {
            //console.log(res)

            if (assessmentStart && this.meta && this.meta.from == Constants.SCHOLARSHIP_MAY_9_2021 && res && res.eventEnd) {
                // this.props.navigation.navigate('LandingScreen')
                //console.log('inside SCHOLARSHIP_MAY_9_2021 ')
                return
            }

            if (res && res.startTime) {
                this.startTime = res.startTime
                this.duration = res.duration
            }

            this.assessmentActivityId = res.assessmentActivityId;
            // this.setState({remainingTime : res.remainingTime})
            this.state.remainingTime = res.remainingTime;

            this.ignoreTimeLimit = res && res.ignoreTimeLimit ? true : false

            if (res.questions && res.questions.length) {

                if (res.resumeId) {

                    for (let i = 0; i < res.questions.length; i++) {
                        if (res.questions[i].id == res.resumeId) {
                            this.setState({ index: i, loading: false }, () => {
                                setTimeout(() => {
                                    if (this.assessmentPaginationComponent) {
                                        this.assessmentPaginationComponent.scrollTo()
                                    }
                                }, 300)

                            })
                            break;
                        }
                    }
                }

                this.getContents(res.questions, this.state.index, (err, response) => {

                    this.setState({
                        questions: res.questions,
                        showTimeUpPopUp: res.remainingTime == 0 ? true : false
                    }, () => {
                        // this.timer()
                        // this.setState({questionLoading : true})
                    })

                    this.currentTime = res.remainingTime
                    this.setState({ currentTime: res.remainingTime })
                    if (err)
                        return;
                })
            }

        }).catch(err => {
            //console.log(err)
            if (err) {
                if (err.response && err.response.data && err.response.data.code == 1701) {
                    this.setState({ showTimeUpPopUp: true })

                    if (err.response.data.response && err.response.data.response.questions) {

                        this.getContents(err.response.data.response.questions, this.state.index, (error, response) => {

                            if (error)
                                return;

                            this.setState({ questions: err.response.data.response.questions, showTimeUpPopUp: true }, () => {

                            })

                        })

                    }
                }
                return;
            }


        })
    }

    getContents = (questions, index, callback) => {


        if (this.meta && this.meta.isFromMyHomework) {
            this.getHomeworkAssessmentContents(questions, index, callback)
            return
        }

        let ids = [];

        for (let i = 0; i < questions.length; i++) {

            if (index <= i) {
                if (ids.length < this.CONTENT_FETCH_LIMIT) {
                    ids.push(questions[i].id)
                }
            }
        }

        let payload = { _id: ids }

        AssessmentApi.getContentList(payload).then((res) => {
            let questionDetailsHash = this.state.questionDetailsHash;
            //console.log(res)

            for (let i = 0; i < res.response.length; i++) {

                let content = res.response[i]
                // console.log(content)

                // if (content.content.type === 12) {
                //     content.content.options = [
                //         {
                //             "id": "158459849165815845984916583222",
                //             "contentType": 1,
                //             "contentTypeName": "TEXT",
                //             "content": "<p>Alaska -42°C</p>",
                //             "order": 1
                //         },
                //         {
                //             "id": "158459850546415845985054646373",
                //             "contentType": 1,
                //             "contentTypeName": "TEXT",
                //             "content": "<p>Ottawa -18°C</p>",
                //             "order": 2
                //         }
                //     ]
                // }
                questionDetailsHash[content._id] = content;

            }

            this.setState({ questionDetailsHash })

            callback && callback(null, res)
        }).catch(err => {
            if (err) {
                callback && callback(err, null)
                return;
            }
        })
    }

    unFlagTheQuestion = () => {

        this.updateActivity({ isFlagged: false }, (err, res) => {

            if (err)
                return;

            let questions = this.state.questions;
            questions[this.state.index]['isFlagged'] = false;
            this.setState({ questions })

        })
    }

    flagTheQuestion = () => {

        this.updateActivity({ isFlagged: true }, (err, res) => {

            if (err)
                return;

            let questions = this.state.questions;
            questions[this.state.index]['isFlagged'] = true;
            this.setState({ questions })

        })
    }


    getHomeworkAssessmentContents = (questions, index, callback) => {

        let ids = [];

        for (let i = 0; i < questions.length; i++) {

            if (index <= i) {
                if (ids.length < this.CONTENT_FETCH_LIMIT) {
                    ids.push(questions[i].id)
                }
            }
        }

        let payload = { ids, questions }

        HomeworkApi.getHomeworkAssessmentContents(payload).then((res) => {
            //console.log(res)

            let questionDetailsHash = this.state.questionDetailsHash;

            for (let i = 0; i < res.data.response.length; i++) {

                let content = res.data.response[i]

                questionDetailsHash[content._id] = content;

            }

            //console.log(questionDetailsHash)

            this.setState({ questionDetailsHash })

            callback && callback(null, res)
        }).catch(err => {
            if (err) {
                callback && callback(err, null)
                return;
            }

        })
    }

    next = () => {

        //console.log('next called')

        if (this.assessmentPaginationComponent) {
            this.assessmentPaginationComponent.scrollTo()
        }


        let answer = this.questionComponent && this.questionComponent.getAnswer();

        //let question = this.state.questions[this.state.index].details;
        let question = this.state.questionDetailsHash[this.state.questions[this.state.index].id];

        if (answer) {
            this.state.questions[this.state.index]['answer'] = answer
            // this.state.questions[this.state.index]['attachments'] = this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : []
            let payload = {
                answer
            }

            if (this.state.questions[this.state.index].attachments && this.state.questions[this.state.index].attachments.length) {
                this.state.attachments[this.state.index] = this.state.questions[this.state.index].attachments
            }

            // if (this.meta && this.meta.isFromMyHomework && question && question.mandatoryAttachments && question.mandatoryAttachments.image && question.mandatoryAttachments.image == true && (!this.state.attachments[this.state.index] || (this.state.attachments[this.state.index] && this.state.attachments[this.state.index].length == 0)) && question.content.isMultiStep && question.content.steps.length - 1 == this.state.stepIndex) {
            //     this.showMedia()
            //     return
            // } else if (this.meta && this.meta.isFromMyHomework && question && question.mandatoryAttachments && question.mandatoryAttachments.image && question.mandatoryAttachments.image == true && (!this.state.attachments[this.state.index] || (this.state.attachments[this.state.index] && this.state.attachments[this.state.index].length == 0)) && !question.content.isMultiStep) {

            //     this.showMedia()
            //     return
            // }

            if (this.state.attachments && this.state.attachments[this.state.index] && this.state.attachments[this.state.index].length) {
                payload['attachments'] = this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : []
                this.state.questions[this.state.index]['attachments'] = this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : []
            }


            if (payload.attachments) {
                this.getSignedUrlForattachments(payload, question)
                return
            }
            this.toggleDisableNext(true)
            this.updateActivity(payload, (err, res) => {

                //console.log('udpated the activity')

                if (err) {
                    this.toggleDisableNext(false)
                    return;
                }

                this.toggleDisableNext(false)

                /** If flagged content rendering while press next */
                if (this.state.isFlaggedContentRendering) {

                    if (this.state.currentFlaggedIndex !== this.flaggedContents.length - 1) {

                        if (question.content.isMultiStep && question.content.steps.length - 1 > this.state.stepIndex) { /** If question is multi step  */
                            this.setState({ stepIndex: this.state.stepIndex + 1, questionLoading: false }, () => {
                                this.setState({ questionLoading: true })
                            });
                        } else {
                            let nextFlaggedIndex = this.state.currentFlaggedIndex + 1

                            if (this.state.questionDetailsHash[this.state.questions[this.flaggedContents[nextFlaggedIndex]].id]) {

                                //console.log('updated the existing content')

                                this.setState({
                                    currentFlaggedIndex: nextFlaggedIndex,
                                    index: this.flaggedContents[nextFlaggedIndex], stepIndex: 0, questionLoading: false
                                }, () => {
                                    this.setState({ questionLoading: true })
                                })

                            } else {

                                this.toggleDisableNext(true)

                                //console.log('updated the content')

                                this.getContents(this.state.questions, this.flaggedContents[nextFlaggedIndex], (err, response) => {

                                    if (err) {
                                        this.toggleDisableNext(false)
                                        return;
                                    }
                                    this.setState({
                                        currentFlaggedIndex: nextFlaggedIndex,
                                        index: this.flaggedContents[nextFlaggedIndex], stepIndex: 0, questionLoading: false
                                    }, () => {
                                        this.setState({ questionLoading: true })
                                    })
                                    this.toggleDisableNext(false)
                                })
                            }
                        }

                        return;

                    }
                }

                if (question.content.isMultiStep && question.content.steps.length - 1 > this.state.stepIndex) { /** If question is multi step  */

                    this.setState({ stepIndex: this.state.stepIndex + 1, questionLoading: false }, () => {
                        this.setState({ questionLoading: true })
                    });
                } else {

                    if (this.state.index !== this.state.questions.length - 1) {


                        if (this.state.questionDetailsHash[this.state.questions[this.state.index + 1].id]) {

                            //console.log('updated the existing content')

                            this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                                this.setState({ questionLoading: true })
                            })

                        } else {

                            this.toggleDisableNext(true)

                            //console.log('updated the content')

                            this.getContents(this.state.questions, this.state.index + 1, (err, response) => {

                                if (err) {
                                    this.toggleDisableNext(false)
                                    return;
                                }
                                this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                                    this.setState({ questionLoading: true })
                                })
                                this.toggleDisableNext(false)
                            })
                        }


                    } else {
                        this.flaggedContents = this.getFlaggedContentIndex()
                        if (this.meta && this.meta.from === 'CASE STUDY') {
                            this.onFinish()
                        } else {
                            this.showAssessEndPopUp()
                        }
                    }
                }
            })
        } else {

            if (this.state.questions[this.state.index].isFlagged) {

                /** If flagged content rendering while press next */
                if (this.state.isFlaggedContentRendering) {

                    if (this.state.currentFlaggedIndex !== this.flaggedContents.length - 1) {

                        let nextFlaggedIndex = this.state.currentFlaggedIndex + 1
                        // this.setState({
                        //     currentFlaggedIndex: nextFlaggedIndex,
                        //     index: this.flaggedContents[nextFlaggedIndex], stepIndex: 0, questionLoading: false
                        // }, () => {
                        //     this.setState({ questionLoading: true })
                        // })
                        if (this.state.questionDetailsHash[this.state.questions[this.flaggedContents[nextFlaggedIndex]].id]) {

                            //console.log('updated the existing content')

                            this.setState({
                                currentFlaggedIndex: nextFlaggedIndex,
                                index: this.flaggedContents[nextFlaggedIndex], stepIndex: 0, questionLoading: false
                            }, () => {
                                this.setState({ questionLoading: true })
                            })

                        } else {

                            this.toggleDisableNext(true)

                            //console.log('updated the content')

                            this.getContents(this.state.questions, this.flaggedContents[nextFlaggedIndex], (err, response) => {

                                if (err) {
                                    this.toggleDisableNext(false)
                                    return;
                                }
                                this.setState({
                                    currentFlaggedIndex: nextFlaggedIndex,
                                    index: this.flaggedContents[nextFlaggedIndex], stepIndex: 0, questionLoading: false
                                }, () => {
                                    this.setState({ questionLoading: true })
                                })
                                this.toggleDisableNext(false)
                            })
                        }

                        return;

                    }
                }

                if (this.state.index !== this.state.questions.length - 1) {

                    if (this.state.questionDetailsHash[this.state.questions[this.state.index + 1].id]) {

                        this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                            this.setState({ questionLoading: true })
                        })

                    } else {
                        this.toggleDisableNext(true)
                        this.getContents(this.state.questions, this.state.index + 1, (err, response) => {

                            if (err) {
                                this.toggleDisableNext(false)
                                return;
                            }

                            this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                                this.setState({ questionLoading: true })
                            })
                            this.toggleDisableNext(false)
                        })

                    }

                } else {
                    this.flaggedContents = this.getFlaggedContentIndex()
                    if (this.meta && this.meta.from === 'CASE STUDY') {
                        this.onFinish()
                    } else {
                        this.showAssessEndPopUp()
                    }
                }

            } else {

                if (this.meta && this.meta.from === 'CASE STUDY') {
                    this.toggleInvalidAnswerModal(true)
                } else {
                    this.showFlagPopUp()
                }
            }
        }
    }


    updateActivity = (payload, callback) => {

        let questionId = this.state.questions[this.state.index].id;

        payload = {
            assessmentActivityId: this.assessmentActivityId,
            questionId,
            ...payload
        }
        this.setState({ disableNext: true })
        let timedOut = false;
        let timeoutId = setTimeout(() => {
            timedOut = true;
            this.showSlowInternetMessageAndStayOnTheSameQuestion()
        }, 3000)
        AssessmentApi.updateMyAsssemetActicity(payload).then((res) => {
            clearTimeout(timeoutId);
            if (timedOut) {
                console.log('received response after timeout')
                return; // Ignore late response
            }
            this.setState({ disableNext: false })
            callback(null, res)
        }).catch(err => {
            clearTimeout(timeoutId);
            if (timedOut) {
                console.log('received response after timeout')
                return; // Ignore late response
            }
            this.setState({ disableNext: false })
            callback(err, null)
        })
    }

    toggleDisableNext = (value) => {
        this.setState({ disableNext: value })
    }




    onClickPage = (page) => {

        if (this.state.stepIndex) {
            this.setState({ stepIndex: 0 })
        }

        let answer = this.questionComponent && this.questionComponent.getAnswer();

        if (answer) {
            this.state.questions[this.state.index]['answer'] = answer
            let payload = {
                answer
            }
            this.updateActivity(payload, (err, res) => {

                if (err)
                    return;
                this.onClickPageContinue(page)
            })
        } else {
            this.onClickPageContinue(page)
        }
    }

    onClickPageContinue = (page) => {
        if (this.state.questionDetailsHash[this.state.questions[page - 1].id]) {

            this.setState({ index: page - 1, isFlaggedContentRendering: false, questionLoading: false }, () => {
                this.setState({ questionLoading: true })
            })
        } else {
            this.getContents(this.state.questions, page - 1, (err, response) => {

                if (err)
                    return;

                this.setState({ index: page - 1, isFlaggedContentRendering: false, questionLoading: false }, () => {
                    this.setState({ questionLoading: true })
                })
            })
        }
    }

    getFlaggedContentIndex = () => {
        let flaggedIndex = [];

        for (let i = 0; i < this.state.questions.length; i++) {
            let question = this.state.questions[i];

            if (question.isFlagged)
                flaggedIndex.push(i)
        }

        return flaggedIndex
    }

    showFlagPopUp = () => {
        //console.log('flag')
        this.setState({ showFlagPopUp: true })
    }

    hideFlagPopUp = (callback) => {
        this.setState({ showFlagPopUp: false }, () => callback && callback())
    }

    showAssessEndPopUp = () => {
        this.setState({ showAssessEndPopUp: true })
    }

    hideAssessEndPopUp = () => {
        this.setState({ showAssessEndPopUp: false })
    }

    onFinish = () => {

        let answer = this.questionComponent && this.questionComponent.getAnswer();

        if (answer) {
            this.state.questions[this.state.index]['answer'] = answer
            let payload = {
                answer
            }
            this.updateActivity(payload, (err, res) => {

                if (err)
                    return;

                this.onPressFinish()
            })

        } else {
            this.onPressFinish()
        }

    }


    onPressFlagYes = () => {
        let questions = this.state.questions;
        questions[this.state.index]['isFlagged'] = true;
        this.setState({ questions })
        this.updateActivity({ isFlagged: true }, (err, res) => {
            if (err)
                return;

            this.hideFlagPopUp(() => {

                if (this.state.index !== this.state.questions.length - 1) {

                    if (this.state.questionDetailsHash[this.state.questions[this.state.index + 1].id]) {
                        this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                            this.setState({ questionLoading: true })
                        })
                    } else {

                        this.getContents(this.state.questions, this.state.index + 1, (err, response) => {

                            if (err)
                                return;

                            this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                                this.setState({ questionLoading: true })
                            })
                        })

                    }
                } else {
                    //console.log('inside review of flagged assessment')

                    if (this.meta && this.meta.from === 'CASE STUDY') {
                        this.onFinish()
                    } else {
                        setTimeout(() => {
                            this.flaggedContents = this.getFlaggedContentIndex()
                            this.showAssessEndPopUp()
                        }, 500)
                    }

                }
            })
        })
    }


    onPressContinue = () => {
        if (this.state.questionDetailsHash[this.state.questions[this.flaggedContents[0]].id]) {
            this.setState({
                index: this.flaggedContents[0],
                showAssessEndPopUp: false,
                isFlaggedContentRendering: true,
                currentFlaggedIndex: 0,
                showFinishFooter: true, stepIndex: 0, questionLoading: false
            }, () => {
                this.setState({ questionLoading: true })
                if (this.assessmentPaginationComponent) {
                    this.assessmentPaginationComponent.scrollTo()
                }
            })
        } else {
            this.getContents(this.state.questions, this.flaggedContents[0], (err, response) => {

                if (err)
                    return;

                this.setState({
                    index: this.flaggedContents[0],
                    showAssessEndPopUp: false,
                    isFlaggedContentRendering: true,
                    currentFlaggedIndex: 0,
                    showFinishFooter: true, stepIndex: 0, questionLoading: false
                }, () => {

                    this.setState({ questionLoading: true })

                    if (this.assessmentPaginationComponent) {
                        this.assessmentPaginationComponent.scrollTo()
                    }
                })
            })
        }
    }

    assessMyAssessment = (callback) => {

        let payload = {
            assessmentActivityId: this.assessmentActivityId
        }


        if (this.meta.isFromMyHomework) {
            payload.homeworkActivityId = this.meta.homeworkActivityId
            payload.isFromMyHomework = true
        }

        if (this.meta.isFromPracticeCaseStudy) {
            payload.practiceActivityId = this.meta.practiceActivityId
            payload.isFromPracticeCaseStudy = true
        }



        if (!this.userInfo.prepkitGuaranteeAssessmentActivity || (this.userInfo.prepkitGuaranteeAssessmentActivity && this.userInfo.prepkitGuaranteeAssessmentActivity.class && this.userInfo.prepkitGuaranteeAssessmentActivity.class != this.userInfo.class)) {
            payload.guaranteeAssessment = true
        }

        AssessmentApi.assessMyAssessment(payload).then((res) => {
            callback(null, res)
        }).catch(err => {
            callback(err, null)
        });

    }

    onPressFinish = () => {
        console.log('finish Pressed')
        this.hideAssessEndPopUp()
        this.assessMyAssessment((err, res) => {
            console.log(err)
            if (err)
                return

            console.log('completed assessment', this.meta, this.props.delegate.showAssessmentEndScreen)

            // if (res && res.guaranteeAssessmentUpdated) {
            //     this.userInfo['prepkitGuaranteeAssessmentActivity'] = {
            //         activityId: this.assessmentActivityId,
            //         class: this.userInfo.class
            //     }

            //     SharedProfile.setProfile(this.userInfo)

            // }

            // clearInterval(this.timerInterval);


            // if (this.landingScreenInstance && this.meta && (this.meta.from == constants.EVENT_BASELINE || this.meta.from == constants.REWARD_EVENT_BASELINE || this.meta.from == constants.TWO_STEP_EVENT_BASELINE || this.meta.from == constants.TWO_STEP_EVENT_FINAL))
            //     this.landingScreenInstance.resumeUserAppTime()

            this.headerComponent.clearIntervalCustom()
            // AppState.removeEventListener('change', this._handleAppStateChange);

            if (this.meta && (this.meta.from == Constants.SCHOLARSHIP_MAY_9_2021 || this.meta.from == Constants.SCHOLARSHIP_EVENT || this.meta.from == Constants.REWARD_EVENT_FINAL || this.meta.from == Constants.TWO_STEP_EVENT_FINAL)) {

                this.props.delegate && this.props.delegate.showScholarshipFeedback && this.props.delegate.showScholarshipFeedback({
                    meta: {
                        data: res.data,
                        chapterTitle: this.chapterTitle,
                        categoryThemeId: this.categoryThemeId,
                        assessmentActivityId: this.assessmentActivityId,
                        chapterKey: this.chapterKey,
                        type: this.meta.type,
                        eventId: this.meta.eventId,
                        from: this.meta.from,
                        selectedChapters: this.meta.selectedChapters,
                        scholarshipEndScreenStaticText: this.meta.scholarshipEndScreenStaticText,
                        viewLeaderboardTime: this.meta.viewLeaderboardTime ? this.meta.viewLeaderboardTime : null,
                        viewAnswerTime: this.meta.viewAnswerTime ? this.meta.viewAnswerTime : null,
                        viewAnswerTimeScreenStaticText: this.meta.viewAnswerTimeScreenStaticText ? this.meta.viewAnswerTimeScreenStaticText : null,
                        eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {},

                    }
                })

                // this.props.navigation.navigate('ScollarShipEndScreen', {
                //     meta: {
                //         data: res,
                //         chapterTitle: this.chapterTitle,
                //         categoryThemeId: this.categoryThemeId,
                //         assessmentActivityId: this.assessmentActivityId,
                //         chapterKey: this.chapterKey,
                //         type: this.meta.type,
                //         eventId: this.meta.eventId,
                //         from: this.meta.from,
                //         selectedChapters: this.meta.selectedChapters
                //     }
                // })
                // moengage.logCustomEvent('Event', { 'User Id': this.userInfo.userId, "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Baseline Status': 'Completed', 'Assessment Finishline Status': 'Completed', "Learning Status": `100% Completed`, 'Viewed Baseline Report': getBooleanValue(!this.meta.eventPayload.viewedBaselineReport), 'Viewed Finishline Report': getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': getBooleanValue(!this.meta.eventPayload.viewedCertificate) })

                FireBaseEvent('Event', {
                    'User Id': this.userInfo.userId,
                    plan: this.userInfo.isSubscribed ? Constants.PREMIUM_PLAN : Constants.BASIC_PLAN,
                    "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Finishline Status': 'Completed', 'Viewed Finishline Report': CommonUtils.getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': CommonUtils.getBooleanValue(!this.meta.eventPayload.viewedCertificate)
                })
                // Facebook.logCustomEvent('Event', { 'User Id': this.userInfo.userId, "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Baseline Status': 'Completed', 'Assessment Finishline Status': 'Completed', "Learning Status": `100% Completed`, 'Viewed Baseline Report': getBooleanValue(!this.meta.eventPayload.viewedBaselineReport), 'Viewed Finishline Report': getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': getBooleanValue(!this.meta.eventPayload.viewedCertificate) })
                // BranchIO.logCustomEvent('Event', { 'User Id': this.userInfo.userId, "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Baseline Status': 'Completed', 'Assessment Finishline Status': 'Completed', "Learning Status": `100% Completed`, 'Viewed Baseline Report': getBooleanValue(!this.meta.eventPayload.viewedBaselineReport), 'Viewed Finishline Report': getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': getBooleanValue(!this.meta.eventPayload.viewedCertificate) })

                return
            }

            if (this.meta && (this.meta.from == Constants.REFRESHER_COURSE || (this.meta.from == Constants.EVENT_BASELINE))) {

                if (this.meta.from == Constants.REFRESHER_COURSE) {
                    FireBaseEvent(FirebaseEvents.DIAGNOSTIC_ASSESSMENT_COMPLETED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? Constants.PREMIUM_PLAN : Constants.BASIC_PLAN });
                    // Facebook.logCustomEvent(FirebaseEvents.DIAGNOSTIC_ASSESSMENT_COMPLETED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
                    // BranchIO.logCustomEvent(FirebaseEvents.DIAGNOSTIC_ASSESSMENT_COMPLETED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
                }

                // this.props.navigation.replace('DiagnosticAssessmentEndScreen', {
                //     meta: {
                //         data: res,
                //         chapterTitle: this.chapterTitle,
                //         categoryThemeId: this.categoryThemeId,
                //         assessmentActivityId: this.assessmentActivityId,
                //         chapterKey: this.chapterKey,
                //         type: this.meta.type,
                //         eventId: this.meta.eventId,
                //         from: this.meta.from,
                //         selectedChapters: this.meta.selectedChapters,
                //         eventThreshold: this.meta.eventThreshold,
                //         refresherCourseId: this.meta.refresherCourseId ? this.meta.refresherCourseId : '',
                //         scholarshipEligibleStaticText: this.meta.scholarshipEligibleStaticText ? this.meta.scholarshipEligibleStaticText : {},
                //         viewAnswerTime: this.meta.viewAnswerTime ? this.meta.viewAnswerTime : null,
                //         viewAnswerTimeScreenStaticText: this.meta.viewAnswerTimeScreenStaticText ? this.meta.viewAnswerTimeScreenStaticText : null,
                //         eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {}
                //     }
                // })
                this.props.delegate && this.props.delegate.showDiagnosticAssessmentEndScreen && this.props.delegate.showDiagnosticAssessmentEndScreen(
                    {
                        data: res.data,
                        chapterTitle: this.chapterTitle,
                        categoryThemeId: this.categoryThemeId,
                        assessmentActivityId: this.assessmentActivityId,
                        chapterKey: this.chapterKey,
                        type: this.meta.type,
                        eventId: this.meta.eventId,
                        from: this.meta.from,
                        selectedChapters: this.meta.selectedChapters,
                        eventThreshold: this.meta.eventThreshold,
                        refresherCourseId: this.meta.refresherCourseId ? this.meta.refresherCourseId : '',
                        scholarshipEligibleStaticText: this.meta.scholarshipEligibleStaticText ? this.meta.scholarshipEligibleStaticText : {},
                        viewAnswerTime: this.meta.viewAnswerTime ? this.meta.viewAnswerTime : null,
                        viewAnswerTimeScreenStaticText: this.meta.viewAnswerTimeScreenStaticText ? this.meta.viewAnswerTimeScreenStaticText : null,
                        eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {},

                    }
                )
                // moengage.logCustomEvent('Event', { 'User Id': this.userInfo.userId, "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Baseline Status': 'Completed', 'Assessment Finishline Status': 'Not Qualified', "Learning Status": `Not Started`, 'Viewed Baseline Report': getBooleanValue(!this.meta.eventPayload.viewedBaselineReport), 'Viewed Finishline Report': getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': getBooleanValue(!this.meta.eventPayload.viewedCertificate) })
                // FireBaseEvent.logCustomEvent('Event', { 'User Id': this.userInfo.userId, "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Baseline Status': 'Completed', 'Assessment Finishline Status': 'Not Qualified', "Learning Status": `Not Started`, 'Viewed Baseline Report': getBooleanValue(!this.meta.eventPayload.viewedBaselineReport), 'Viewed Finishline Report': getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': getBooleanValue(!this.meta.eventPayload.viewedCertificate) })
                // Facebook.logCustomEvent('Event', { 'User Id': this.userInfo.userId, "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Baseline Status': 'Completed', 'Assessment Finishline Status': 'Not Qualified', "Learning Status": `Not Started`, 'Viewed Baseline Report': getBooleanValue(!this.meta.eventPayload.viewedBaselineReport), 'Viewed Finishline Report': getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': getBooleanValue(!this.meta.eventPayload.viewedCertificate) })
                // BranchIO.logCustomEvent('Event', { 'User Id': this.userInfo.userId, "Event Name": this.meta.eventPayload.title, 'Explored': 'Yes', 'Assessment Baseline Status': 'Completed', 'Assessment Finishline Status': 'Not Qualified', "Learning Status": `Not Started`, 'Viewed Baseline Report': getBooleanValue(!this.meta.eventPayload.viewedBaselineReport), 'Viewed Finishline Report': getBooleanValue(!this.meta.eventPayload.viewedFinishlineReport), 'Viewed Event Certificate': getBooleanValue(!this.meta.eventPayload.viewedCertificate) })

                return

            }

            if (this.meta && this.meta.from == "CASE STUDY") {

                this.props.delegate && this.props.delegate.showPracticeCaseStudyEndScreen && this.props.delegate.showPracticeCaseStudyEndScreen(
                    {
                        data: res.data,
                        chapterTitle: this.chapterTitle,
                        categoryThemeId: this.categoryThemeId,
                        assessmentActivityId: this.assessmentActivityId,
                        chapterKey: this.chapterKey,
                        type: this.meta.type,
                        from: this.meta.from,
                        selectedChapters: this.meta.selectedChapters,

                        // eventThreshold: this.meta.eventThreshold,
                        // refresherCourseId: this.meta.refresherCourseId ? this.meta.refresherCourseId : '',
                        // scholarshipEligibleStaticText: this.meta.scholarshipEligibleStaticText ? this.meta.scholarshipEligibleStaticText : {},
                        // viewAnswerTime: this.meta.viewAnswerTime ? this.meta.viewAnswerTime : null,
                        // viewAnswerTimeScreenStaticText: this.meta.viewAnswerTimeScreenStaticText ? this.meta.viewAnswerTimeScreenStaticText : null,
                        // eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {}
                    }
                )

                return;
            }


            FireBaseEvent(FirebaseEvents.ASSESSMENT_COMPLETED,
                {
                    'User Id': this.userInfo.userId,
                    Status: 'Completed',
                    name: this.userInfo.name, phone: this.userInfo.mobileNumber,
                    countryCode: this.userInfo.countryCode, gender: this.userInfo.gender,
                    class: this.userInfo.class,
                    'School': this.userInfo.schoolName,
                    plan: this.userInfo.isSubscribed ? Constants.PREMIUM_PLAN : Constants.BASIC_PLAN,
                    chapters: this.meta.homeworkChapters ? this.meta.homeworkChapters : "",
                    // 'Chapter Key': this.meta.homework.chapterKey ? this.meta.homework.chapterKey : '',
                    'Starting Point': Constants.SCHOOL_ASSIGNMENT,
                    "Assignment Type": this.meta.homework && this.meta.homework.type === "ASSESSMENT" ? "STANDARD ASSESSMENT" : this.meta.homework ? this.meta.homework.type.replace('_', " ") : 'Chapter Assessment',
                    'Completed Date': new Date().toLocaleDateString()
                });
            // Facebook.logCustomEvent(FirebaseEvents.ASSESSMENT_COMPLETED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });
            // BranchIO.logCustomEvent(FirebaseEvents.ASSESSMENT_COMPLETED, { name: this.userInfo.name, phone: this.userInfo.mobileNumber, countryCode: this.userInfo.countryCode, gender: this.userInfo.gender, class: this.userInfo.class, plan: this.userInfo.isSubscribed ? constants.PREMIUM_PLAN : constants.BASIC_PLAN });

            if (this.meta && this.meta.isFromMyHomework && this.meta.homework && this.meta.homeworkChapters) {

                // moengage.logCustomEvent('Homework Completion', { 'User Id': this.userInfo.userId, 'Class': this.userInfo.class, 'School': this.userInfo.schoolName, status: 'Completed', 'Homework Type': 'Assessment', 'Chapter Key': this.meta.homework.chapterKey ? this.meta.homework.chapterKey : '', Chapters: this.meta.homeworkChapters ? this.meta.homeworkChapters : '', 'Starting Point': 'Homework', 'Completed Date': new Date().toLocaleDateString() })
                FireBaseEvent('Assessment Completion', {
                    'User Id': this.userInfo.userId,
                    Status: 'Completed',
                    name: this.userInfo.name, phone: this.userInfo.mobileNumber,
                    countryCode: this.userInfo.countryCode, gender: this.userInfo.gender,
                    class: this.userInfo.class,
                    'School': this.userInfo.schoolName,
                    plan: this.userInfo.isSubscribed ? Constants.PREMIUM_PLAN : Constants.BASIC_PLAN,
                    chapters: this.meta.homeworkChapters ? this.meta.homeworkChapters : "",
                    // 'Chapter Key': this.meta.homework.chapterKey ? this.meta.homework.chapterKey : '',
                    'Starting Point': Constants.SCHOOL_ASSIGNMENT,
                    "Assignment Type": this.meta.homework.type === "ASSESSMENT" ? "STANDARD ASSESSMENT" : this.meta.homework.type.replace('_', " "),
                    'Completed Date': new Date().toLocaleDateString()
                })
                // Facebook.logCustomEvent('Homework Completion', { 'User Id': this.userInfo.userId, 'Class': this.userInfo.class, 'School': this.userInfo.schoolName, status: 'Completed', 'Homework Type': 'Assessment', 'Chapter Key': this.meta.homework.chapterKey ? this.meta.homework.chapterKey : '', Chapters: this.meta.homeworkChapters ? this.meta.homeworkChapters : '', 'Starting Point': 'Homework', 'Completed Date': new Date().toLocaleDateString() })
                // BranchIO.logCustomEvent('Homework Completion', { 'User Id': this.userInfo.userId, 'Class': this.userInfo.class, 'School': this.userInfo.schoolName, status: 'Completed', 'Homework Type': 'Assessment', 'Chapter Key': this.meta.homework.chapterKey ? this.meta.homework.chapterKey : '', Chapters: this.meta.homeworkChapters ? this.meta.homeworkChapters : '', 'Starting Point': 'Homework', 'Completed Date': new Date().toLocaleDateString() })
            }



            this.props.delegate && this.props.delegate.showAssessmentEndScreen && this.props.delegate.showAssessmentEndScreen({
                data: res.data,
                percentage: (res.data.markScored / res.data.totalMark) * 100,
                chapterTitle: this.chapterTitle,
                categoryThemeId: this.categoryThemeId,
                assessmentActivityId: this.assessmentActivityId,
                chapterKey: this.chapterKey,
                type: this.meta.type,
                eventId: this.meta.eventId,
                from: this.meta.from,
                selectedChapters: this.meta.selectedChapters,
                scholarshipEligibleStaticText: this.meta.scholarshipEligibleStaticText ? this.meta.scholarshipEligibleStaticText : {},
                eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {},
                isExamPrepKit: this.meta && this.meta.isExamPrepKit ? this.meta.isExamPrepKit : "",
                isFromMyHomework: this.meta && this.meta.isFromMyHomework,
                isDueDatePassed: this.meta && this.meta.isDueDatePassed,
                viewAnswerTime: this.meta && this.meta.viewAnswerTime,
                homework: this.meta.homework ? this.meta.homework : res.data.homework ? res.data.homework : {}
                // from: this.meta.from
            })


            // this.props.navigation.navigate('AssessmentEndScreen', {
            //     meta: {
            //         data: res,
            //         percentage: (res.markScored / res.totalMark) * 100,
            //         chapterTitle: this.chapterTitle,
            //         categoryThemeId: this.categoryThemeId,
            //         assessmentActivityId: this.assessmentActivityId,
            //         chapterKey: this.chapterKey,
            //         type: this.meta.type,
            //         eventId: this.meta.eventId,
            //         from: this.meta.from,
            //         selectedChapters: this.meta.selectedChapters,
            //         scholarshipEligibleStaticText: this.meta.scholarshipEligibleStaticText ? this.meta.scholarshipEligibleStaticText : {},
            //         eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {},
            //         isExamPrepKit: this.meta && this.meta.isExamPrepKit ? this.meta.isExamPrepKit : "",
            //         isFromMyHomework: this.meta && this.meta.isFromMyHomework,
            //         isDueDatePassed: this.meta && this.meta.isDueDatePassed,
            //         viewAnswerTime: this.meta && this.meta.viewAnswerTime
            //     }
            // })


        })
    }

    onPressReviewAnswers = () => {

        if (this.state.questionDetailsHash[this.state.questions[0].id]) {
            this.setState({ showFinishFooter: true, index: 0, stepIndex: 0, questionLoading: false }, () => {
                this.setState({ questionLoading: true })
                if (this.assessmentPaginationComponent) {
                    this.assessmentPaginationComponent.scrollTo()
                }
            })
            this.hideAssessEndPopUp()
        } else {
            this.getContents(this.state.questions, 0, (err, response) => {

                if (err)
                    return;

                this.setState({ showFinishFooter: true, index: 0, stepIndex: 0, questionLoading: false }, () => {
                    this.setState({ questionLoading: true })
                    if (this.assessmentPaginationComponent) {
                        this.assessmentPaginationComponent.scrollTo()
                    }
                })
                this.hideAssessEndPopUp()
            })
        }
    }

    onPressTimeUpContinue = () => {
        this.setState({ showTimeUpPopUp: false })
        this.onPressFinish()
    }

    setCurrentTime = (time) => {
        this.currentTime = time
        this.state.remainingTime = time
        this.setState({ currentTime: time })
    }


    onTimerEnd = () => {

        if (this.ignoreTimeLimit)
            return;

        if (this.state.showAssessEndPopUp) {
            this.setState({ showAssessEndPopUp: false }, () => {
                setTimeout(() => {
                    this.setState({ showTimeUpPopUp: true })
                }, 500)
            })
        } else
            this.setState({ showTimeUpPopUp: true })

    }

    toggleInvalidAnswerModal = (value) => {
        this.setState({ showInvalidAnswerModal: value, questionLoading: false }, () => {
            this.setState({ questionLoading: true })
        });
    }

    onOk = () => {
        this.toggleInvalidAnswerModal(false);
    }




    render() {

        //   //console.log(this.state.questionDetailsHash)
        //   //console.log(this.state.questions)

        let content = this.state.questions && this.state.questions.length ? this.state.questionDetailsHash[this.state.questions[this.state.index].id] : null

        // single select
        // content = {
        //     "_id": "618222ff2f081330c715fc12",
        //     "title": "",
        //     "displayTitle": "",
        //     "type": 5,
        //     "typeName": "ASSESSMENT QUESTION",
        //     "content": {
        //         "type": 1,
        //         "typeName": "SINGLE SELECT",
        //         "title": "<p>In a class of <cw-math data=\"60\">60</cw-math> students, <cw-math data=\"\\frac{1}{5}\">\\frac{1}{5}</cw-math>of the total number of students play football, <cw-math data=\"\\frac{2}{5}\">\\frac{2}{5}</cw-math>&nbsp;of the total number play cricket and the remaining students play kho-kho.</p><p>&nbsp;</p><p>Find the number of students who plays each type of sports. is<cw-blank>_____</cw-blank><cw-blank>_____</cw-blank></p>",
        //         "images": [
        //             {
        //                 "imageUrl": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png"
        //             },
        //             // {
        //             //     "imageUrl" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png"
        //             // }, 
        //             // {
        //             //     "imageUrl" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png"
        //             // },
        //             // {
        //             //     "imageUrl" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png"
        //             // }
        //         ],
        //         "complexityId": "5e8ebdf8d979fe12d6310080",
        //         "duration": 1,
        //         "mark": 1,
        //         "solutionSteps": {
        //             "type": "",
        //             "typeName": "",
        //             "question": [],
        //             "steps": [],
        //             "conclusion": "",
        //             "summarySolution": "<p>Smallest 5 digit number = 10,000</p><p> </p><p>10,000 – 1 = 9,999 which is the greatest 4 digit number.</p><p> </p><p>Hence, 1 subtracted from the smallest 5 digit number is the greatest 4 digit number.</p>"
        //         },
        //         "options": [
        //             {
        //                 "id": "163591851670916359185167099091",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>Greatest 4 digit number</p>",
        //                 "isCorrect": true
        //             },
        //             {
        //                 "id": "163591851904916359185190491407",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>Greatest 5 digit number</p>",
        //                 "isCorrect": false
        //             },
        //             {
        //                 "id": "163591852022616359185202264036",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>Smallest 4 digit number</p>",
        //                 "isCorrect": false
        //             },
        //             {
        //                 "id": "163591852220416359185222048748",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>Smallest 5 digit number</p>",
        //                 "isCorrect": false
        //             }
        //         ]
        //         // "options" : [
        //         //     {
        //         //         "id": "160488576789816048857678983828",
        //         //         "contentType": 1,
        //         //         "contentTypeName": "TEXT",
        //         //         "content": "<p><cw-math data=\"78\\frac{85}{69}\">78\\frac{85}{69}</cw-math>&nbsp;Test 10</p>",
        //         //         "isCorrect": true
        //         //     },
        //         //     {
        //         //         "id": "160488578944616048857894467479",
        //         //         "contentType": 1,
        //         //         "contentTypeName": "TEXT",
        //         //         "content": "<p>Test 20</p>",
        //         //         "isCorrect": false
        //         //     },
        //         //     {
        //         //         "id": "160578762402116057876240218094",
        //         //         "contentType": 2,
        //         //         "contentTypeName": "IMAGE",
        //         //         "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png",
        //         //         "isCorrect": false
        //         //     },
        //         //     {
        //         //         "id": "160933561372616093356137267309",
        //         //         "contentType": 2,
        //         //         "contentTypeName": "IMAGE",
        //         //         "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png",
        //         //         "isCorrect": false
        //         //     }
        //         // ]
        //     },
        //     "notes": {
        //         "error": "",
        //         "success": ""
        //     },
        //     "createdDate": 1635918591669,
        //     "createdBy": "",
        //     "updatedDate": 1635918591669,
        //     "updatedBy": "",
        //     "state": "",
        //     "author": "",
        //     "parallel": [],
        //     "hint": "",
        //     "comprehension": [],
        //     "mandatoryAttachments": {
        //         "audio": false,
        //         "video": false,
        //         "image": false
        //     },
        //     "countingwellCreatedTimestamp": "2021-11-03T05:49:51.677Z",
        //     "countingwellLastUpdateTimestamp": "2021-11-03T05:49:51.677Z"
        // }

        // multi Select  

        // content = {
        //     "_id":"5fc0f3fe62922d719cfbf4ea",
        //     "title": "",
        //     "displayTitle": "",
        //     "type": 5,
        //     "typeName": "ASSESSMENT QUESTION",
        //     "content": {
        //         "type": 2,
        //         "typeName": "MULTI SELECT",
        //         "title": "<p>In a class of <cw-math data=\"60\">60</cw-math> students, <cw-math data=\"\\frac{1}{5}\">\\frac{1}{5}</cw-math>of the total number of students play football, <cw-math data=\"\\frac{2}{5}\">\\frac{2}{5}</cw-math>&nbsp;of the total number play cricket and the remaining students play kho-kho.</p><p>&nbsp;</p><p>Find the number of students who plays each type of sports. is<cw-blank>_____</cw-blank><cw-blank>_____</cw-blank></p>",
        //         "images": [
        //             {
        //                 "imageUrl": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/f45e3421-533e-496f-a8f4-26cddbffee26-Slide%201%20_%20Question.png"
        //             }
        //         ],
        //         "complexityId": "5e71f90f5c3254149568b8a9",
        //         "duration": 1,
        //         "mark": 5,
        //         "solutionSteps": {
        //             "type": "",
        //             "typeName": "",
        //             "question": [],
        //             "steps": [],
        //             "conclusion": "",
        //             "summarySolution": "<p>From the given rectangle we can see that,</p><p>&nbsp;</p><p><img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/79184e46-5aa5-4907-9c33-8660fd7c60c4-Slide%201%20_%20Solution%20A.png\" style=\"height:313px; width:500px\" /></p><p><img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/e93f1349-42b5-4380-8aed-29414610df12-Slide%201%20_%20Solution%20B.png\" style=\"height:313px; width:500px\" /></p><p><img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/9d854ac4-6089-4b55-ab8e-0841c3b6ce45-Slide%201%20_%20Solution%20C.png\" style=\"height:449px; width:400px\" /></p><p><img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/001f884b-069e-4427-a189-9929e271e6c1-Slide%201%20_%20Solution%20D.png\" style=\"height:449px; width:400px\" /></p><p><cw-math data=\"\\triangle AED\">\\triangle AED</cw-math> and&nbsp;<cw-math data=\"\\triangle BEC\">\\triangle BEC</cw-math> have the same dimensions, i.e.</p><p>&nbsp;</p><p>AE = EB = 5 cm,</p><p>&nbsp;</p><p>ED = EC = 7 cm,</p><p>&nbsp;</p><p>AD is parallel to BC in the rectangle ABCD, therefore, AD = BC</p><p>&nbsp;</p><p><cw-math data=\"\\triangle AED\">\\triangle AED</cw-math> and <cw-math data=\"\\triangle BEC\">\\triangle BEC</cw-math>&nbsp;can be overlapped onto each other.</p><p>&nbsp;</p><p>Similarly, BEDC and AECD have the same dimensions, i.e</p><p>&nbsp;</p><p>AE = EB = 5 cm</p><p>&nbsp;</p><p>ED = EC = 7 cm,</p><p>&nbsp;</p><p>DC = DC = 10 cm, common side.</p><p>&nbsp;</p><p>AD is parallel to BC in the rectangle ABCD, therefore, AD = BC</p><p>&nbsp;</p><p>Therefore, <cw-math data=\"\\triangle AED\">\\triangle AED</cw-math> and&nbsp;<cw-math data=\"\\triangle BEC\">\\triangle BEC</cw-math> are congruent.</p><p>&nbsp;</p><p>BEDC and AECD are congruent.</p>"
        //         },
        //         "options": [
        //             {
        //                 "id": "160648024077616064802407765664",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>AED and BEC</p>",
        //                 "isCorrect": true
        //             },
        //             {
        //                 "id": "160648024846116064802484611820",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>DEC and ECB</p>",
        //                 "isCorrect": false
        //             },
        //             {
        //                 "id": "160648025469316064802546930109",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>DEC and AED</p>",
        //                 "isCorrect": false
        //             },
        //             {
        //                 "id": "160648026088416064802608846205",
        //                 "contentType": 1,
        //                 "contentTypeName": "TEXT",
        //                 "content": "<p>AECD and BEDC</p>",
        //                 "isCorrect": true
        //             }
        //         ]
        //     },
        //     "notes": {
        //         "error": "",
        //         "success": ""
        //     },
        //     "createdDate": 1606480894467.0,
        //     "createdBy": "",
        //     "updatedDate": 1638770028220.0,
        //     "updatedBy": "",
        //     "state": "",
        //     "author": "",
        //     "parallel": [],
        //     "hint": "",
        //     "comprehension": [],
        //     "mandatoryAttachments": {
        //         "audio": false,
        //         "video": false,
        //         "image": false
        //     }
        // }

        // Fill in the blank

        // content = {
        //     "_id" : "618227302f081330c715fc29",
        //     "title" : "",
        //     "displayTitle" : "",
        //     "type" : 5,
        //     "typeName" : "ASSESSMENT QUESTION",
        //     "content" : {
        //         "type" : 3,
        //         "typeName" : "FILL IN THE BLANK",
        //         "title" : "<p>2,34,618 rounded off to the nearest hundreds is <cw-blank>_____</cw-blank> .</p><p>&nbsp;</p><p>2,34,618 rounded off to the nearest thousands is <cw-blank>_____</cw-blank> .</p><p>&nbsp;</p><p>2,34,618 rounded off to the nearest ten thousands is <cw-blank>_____</cw-blank> .</p><p>2,34,618 rounded off to the nearest ten thousands is <cw-blank>_____</cw-blank> .</p><p>2,34,618 rounded off to the nearest ten thousands is <cw-blank>_____</cw-blank> .</p>",
        //         "images" : [],
        //         "complexityId" : "5e71f8fe5c3254149568b8a8",
        //         "duration" : 3,
        //         "mark" : 3,
        //         "solutionSteps" : {
        //             "type" : "",
        //             "typeName" : "",
        //             "question" : [],
        //             "steps" : [],
        //             "conclusion" : "",
        //             "summarySolution" : "<ul><li>2,34,618 rounded off to the nearest hundreds is 2,34,600.</li><li>2,34,618 rounded off to the nearest thousands is 2,35,000.</li><li>2,34,618 rounded off to the nearest ten thousands is 2,30,000.</li></ul>"
        //         },
        //         "options" : [ 
        //             {
        //                 "id" : "160654154224216065415422423570",
        //                 "contentType" : 3,
        //                 "contentTypeName" : "BLANK",
        //                 "contentDataType" : 1,
        //                 "contentDataTypeName" : "NUMERIC",
        //                 "items" : [ 
        //                     {
        //                         "id" : "160654154224216065415422422719",
        //                         "content" : "<p><cw-math data=\"600134\">600134</cw-math></p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT"
        //                     }, 
        //                     {
        //                         "id" : "162219144911016221914491102618",
        //                         "content" : "<p><cw-math data=\"6,00,134\">6,00,134</cw-math></p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT"
        //                     }
        //                 ]
        //             }, 
        //             {
        //                 "id" : "160654154459016065415445902935",
        //                 "contentType" : 3,
        //                 "contentTypeName" : "BLANK",
        //                 "contentDataType" : 1,
        //                 "contentDataTypeName" : "NUMERIC",
        //                 "items" : [ 
        //                     {
        //                         "id" : "160654154459016065415445907002",
        //                         "content" : "<p><cw-math data=\"794791\">794791</cw-math></p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT"
        //                     }, 
        //                     {
        //                         "id" : "162219146448716221914644875609",
        //                         "content" : "<p><cw-math data=\"7,94,791\">7,94,791</cw-math></p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT"
        //                     }
        //                 ]
        //             }, 
        //             {
        //                 "id" : "163591954621416359195462149096",
        //                 "contentType" : 4,
        //                 "contentTypeName" : "DROPDOWN",
        //                 "items" : [ 
        //                     {
        //                         "id" : "163591957294516359195729451748",
        //                         "content" : "<p>2,34,600</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : true
        //                     }, 
        //                     {
        //                         "id" : "163591957876916359195787690628",
        //                         "content" : "<p>2,34,500</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : false
        //                     }, 
        //                     {
        //                         "id" : "163591958128516359195812859174",
        //                         "content" : "<p>2,34,400</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : false
        //                     }
        //                 ]
        //             }, 
        //             {
        //                 "id" : "163591955235316359195523537189",
        //                 "contentType" : 4,
        //                 "contentTypeName" : "DROPDOWN",
        //                 "items" : [ 
        //                     {
        //                         "id" : "163591959940916359195994097182",
        //                         "content" : "<p>2,35,000</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : true
        //                     }, 
        //                     {
        //                         "id" : "163591960987016359196098705928",
        //                         "content" : "<p>2,34,000</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : false
        //                     }, 
        //                     {
        //                         "id" : "163591961211616359196121162886",
        //                         "content" : "<p>2,33,000</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : false
        //                     }
        //                 ]
        //             }, 
        //             {
        //                 "id" : "163591955877716359195587772851",
        //                 "contentType" : 4,
        //                 "contentTypeName" : "DROPDOWN",
        //                 "items" : [ 
        //                     {
        //                         "id" : "163591962841716359196284170116",
        //                         "content" : "<p>2,30,000</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : true
        //                     }, 
        //                     {
        //                         "id" : "163591963385416359196338545201",
        //                         "content" : "<p>2,40,000</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : false
        //                     }, 
        //                     {
        //                         "id" : "163591963600016359196360002753",
        //                         "content" : "<p>2,35,000</p>",
        //                         "contentType" : 1,
        //                         "contentTypeName" : "TEXT",
        //                         "isCorrect" : false
        //                     }
        //                 ]
        //             }
        //         ]
        //     },
        //     "notes" : {
        //         "error" : "",
        //         "success" : ""
        //     },
        //     "createdDate" : 1635919664830.0,
        //     "createdBy" : "",
        //     "updatedDate" : 1635919664830.0,
        //     "updatedBy" : "",
        //     "state" : "",
        //     "author" : "",
        //     "parallel" : [],
        //     "hint" : "",
        //     "comprehension" : [],
        //     "mandatoryAttachments" : {
        //         "audio" : false,
        //         "video" : false,
        //         "image" : false
        //     },

        // }

        //sequence 

        // content = {
        //     "_id" :"5fbf8c1462922d719cfbed0a",
        //     "title" : "Calculation - M2",
        //     "displayTitle" : "",
        //     "type" : 1,
        //     "typeName" : "ASSESSMENT CONTENT",
        //     "content" : {
        //         "type" : 5,
        //         "typeName" : "SEQUENCE",
        //         "title" : "<p>Arrange the given rational numbers in ascending order.</p>",
        //         "images" : [],
        //         "mark" : 3,
        //         "solutionSteps" : {
        //             "type" : "",
        //             "typeName" : "",
        //             "question" : [],
        //             "steps" : [],
        //             "conclusion" : "",
        //             "summarySolution" : "<p>The denominators of the given rational numbers are positive.</p><p>&nbsp;</p><p>The denominators are&nbsp;3, 9, 3 and 9.</p><p>&nbsp;</p><p>Their LCM is 9.</p><p>&nbsp;</p><p>Writing the numbers so that they have a common denominator 9&nbsp;as follows:</p><p>&nbsp;</p><p><cw-math data=\"\\frac{1}{3}=\\frac{1\\times3}{3\\times3}=\\frac{3}{9}\">\\frac{1}{3}=\\frac{1\\times3}{3\\times3}=\\frac{3}{9}</cw-math></p><p>&nbsp;</p><p><cw-math data=\"\\frac{2}{9}=\\frac{2\\times1}{9\\times1}=\\frac{2}{9}\">\\frac{2}{9}=\\frac{2\\times1}{9\\times1}=\\frac{2}{9}</cw-math></p><p>&nbsp;</p><p><cw-math data=\"\\frac{-1}{9}=\\frac{-1\\times1}{9\\times1}=\\frac{-1}{9}\">\\frac{-1}{9}=\\frac{-1\\times1}{9\\times1}=\\frac{-1}{9}</cw-math></p><p>&nbsp;</p><p><cw-math data=\"\\frac{-2}{3}=\\frac{-2\\times3}{3\\times3}=\\frac{-6}{9}\">\\frac{-2}{3}=\\frac{-2\\times3}{3\\times3}=\\frac{-6}{9}</cw-math></p><p>&nbsp;</p><p>Arranging the numerators of these rational numbers in ascending order, we get</p><p>&nbsp;</p><p><cw-math data=\"-6&amp;lt;-1&amp;lt;2&amp;lt;3\">-6&lt;-1&lt;2&lt;3</cw-math></p><p>&nbsp;</p><p><cw-math data=\"\\frac{-6}{9}&amp;lt;\\frac{-1}{9}&amp;lt;\\frac{2}{9}&amp;lt;\\frac{3}{9}\">\\frac{-6}{9}&lt;\\frac{-1}{9}&lt;\\frac{2}{9}&lt;\\frac{3}{9}</cw-math></p><p>&nbsp;</p><p><cw-math data=\"\\frac{-2}{3}&amp;lt;\\frac{-1}{9}&amp;lt;\\frac{2}{9}&amp;lt;\\frac{1}{3}\">\\frac{-2}{3}&lt;\\frac{-1}{9}&lt;\\frac{2}{9}&lt;\\frac{1}{3}</cw-math></p><p>&nbsp;</p><p>Hence, the&nbsp;rational numbers in ascending order are as follows.</p><p>&nbsp;</p><p><cw-math data=\"\\frac{-2}{3},\\frac{-1}{9},\\frac{2}{9},\\frac{1}{3}\">\\frac{-2}{3},\\frac{-1}{9},\\frac{2}{9},\\frac{1}{3}</cw-math></p>"
        //         },
        //         "options" : [ 
        //             {
        //                 "id" : "160343700940416034370094048156",
        //                 "contentType" : 1,
        //                 "contentTypeName" : "TEXT",
        //                 "content" : "<p>1</p>",
        //                 "order" : 1
        //             }, 
        //             {
        //                 "id" : "160343706418916034370641897594",
        //                 "contentType" : 1,
        //                 "contentTypeName" : "TEXT",
        //                 "content" : "<p>2</p>",
        //                 "order" : 2
        //             }, 
        //             {
        //                 "id" : "160343707331316034370733137668",
        //                 "contentType" : 1,
        //                 "contentTypeName" : "TEXT",
        //                 "content" : "<p>3</p>",
        //                 "order" : 3
        //             }, 
        //             {
        //                 "id" : "160343708310616034370831063095",
        //                 "contentType" : 1,
        //                 "contentTypeName" : "TEXT",
        //                 "content" : "<p>4</p>",
        //                 "order" : 4
        //             }
        //         ]
        //     },
        //     "notes" : {
        //         "error" : "",
        //         "success" : ""
        //     },
        //     "createdDate" : 1601095212216.0,
        //     "createdBy" : "",
        //     "updatedDate" : 1619863345148.0,
        //     "updatedBy" : "",
        //     "state" : "",
        //     "author" : "",
        //     "parallel" : [],
        //     "hint" : "<p>Find LCM of denominators and convert each rational number with this LCM as their denominator</p>",
        //     "comprehension" : [],
        //     "mandatoryAttachments" : {
        //         "audio" : false,
        //         "video" : false,
        //         "image" : false
        //     },
        //     "parallelTo" : "5f6ec62fac7ec8040173113f"
        // }

        // Matching 

        // content = {
        //     "_id" : "6007e632062e1d316d54dd0e",
        //     "title" : "",
        //     "displayTitle" : "",
        //     "type" : 5,
        //     "typeName" : "ASSESSMENT QUESTION",
        //     "content" : {
        //         "type" : 4,
        //         "typeName" : "MATCHING",
        //         "title" : "<p>Match with the opposite of each of the following.</p>",
        //         "images" : [
        //             //             {
        //             //     "imageUrl": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png"
        //             // },
        //             // {
        //             //     "imageUrl" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/a12094d4-a791-4589-8de1-c0ba64418282-1.png"
        //             // },
        //         ],
        //         "complexityId" : "5e8ebdf8d979fe12d6310080",
        //         "duration" : 1,
        //         "mark" : 10,
        //         "solutionSteps" : {
        //             "type" : "",
        //             "typeName" : "",
        //             "question" : [],
        //             "steps" : [],
        //             "conclusion" : "",
        //             "summarySolution" : "<p>The opposite of :</p><ul><li>Increase in 4 kg weight is decrease in 4 kg weight</li><li>4&nbsp;km north is 4&nbsp;km south</li><li>Loss of ₹400 is gain of ₹400</li><li>400 m above sea level is 400 m below sea level</li></ul>"
        //         },
        //         // "options" : [ 
        //         //     {
        //         //         "id" : "161113041762416111304176248138",
        //         //         "question" : {
        //         //             "content" : "<p>Increase in 4 kg weight</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113031973016111303197301431"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>Decrease in 4 kg weight</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113031973016111303197306306"
        //         //         }
        //         //     }, 
        //         //     {
        //         //         "id" : "161113041762416111304176245952",
        //         //         "question" : {
        //         //             "content" : "<p>4 km north</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113033469816111303346989572"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>4 km south</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113033469816111303346983529"
        //         //         }
        //         //     }, 
        //         //     {
        //         //         "id" : "161113041762416111304176248662",
        //         //         "question" : {
        //         //             "content" : "<p>Loss of ₹400</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113035295816111303529583650"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>Gain of ₹400</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113035295816111303529585184"
        //         //         }
        //         //     }, 
        //         //     {
        //         //         "id" : "161113041762416111304176249409",
        //         //         "question" : {
        //         //             "content" : "<p>400 m above sea level</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113037203816111303720380803"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>400 m below sea level</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161113037203816111303720386583"
        //         //         }
        //         //     }
        //         // ]
        //         // "options" : [ 
        //         //     {
        //         //         "id" : "161117811453516111781145355175",
        //         //         "question" : {
        //         //             "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/570522c0-5629-4c84-9e4d-c93638f74abe-3a.png",
        //         //             "contentType" : 2,
        //         //             "contentTypeName" : "IMAGE",
        //         //             "id" : "161117804578516111780457853283"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>Acute angle</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161117804578516111780457859196"
        //         //         }
        //         //     }, 
        //         //     {
        //         //         "id" : "161117811453516111781145353478",
        //         //         "question" : {
        //         //             "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/9735f9c1-557b-48a6-8718-487374399e47-3b.png",
        //         //             "contentType" : 2,
        //         //             "contentTypeName" : "IMAGE",
        //         //             "id" : "161117805889616111780588962402"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>Right angle</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161117805889616111780588965593"
        //         //         }
        //         //     }, 
        //         //     {
        //         //         "id" : "161117811453516111781145358367",
        //         //         "question" : {
        //         //             "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/afe469a8-08b5-4aba-9565-9715a001e86c-3c.png",
        //         //             "contentType" : 2,
        //         //             "contentTypeName" : "IMAGE",
        //         //             "id" : "161117806018716111780601878313"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>Obtuse angle</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161117806018716111780601873355"
        //         //         }
        //         //     }, 
        //         //     {
        //         //         "id" : "161117811453516111781145355077",
        //         //         "question" : {
        //         //             "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/f0fcc7cd-cc1f-4386-9fca-1c593f1dcc4f-3d.png",
        //         //             "contentType" : 2,
        //         //             "contentTypeName" : "IMAGE",
        //         //             "id" : "161117806154316111780615432940"
        //         //         },
        //         //         "answer" : {
        //         //             "content" : "<p>Straight angle</p>",
        //         //             "contentType" : 1,
        //         //             "contentTypeName" : "TEXT",
        //         //             "id" : "161117806154316111780615434524"
        //         //         }
        //         //     }
        //         // ]
        //         "options" : [ 
        //             {
        //                 "id" : "160995141471316099514147132986",
        //                 "question" : {
        //                     "content" : "<p>Top view</p>",
        //                     "contentType" : 1,
        //                     "contentTypeName" : "TEXT",
        //                     "id" : "160995126530916099512653099975"
        //                 },
        //                 "answer" : {
        //                     "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/b0dc82a3-8471-48e8-af5b-0ac92b0d2bb1-26a.png",
        //                     "contentType" : 2,
        //                     "contentTypeName" : "IMAGE",
        //                     "id" : "160995126530916099512653093996"
        //                 }
        //             }, 
        //             {
        //                 "id" : "160995141471316099514147135712",
        //                 "question" : {
        //                     "content" : "<p>Side view</p>",
        //                     "contentType" : 1,
        //                     "contentTypeName" : "TEXT",
        //                     "id" : "160995126640516099512664055935"
        //                 },
        //                 "answer" : {
        //                     "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/7c7a866d-3ed3-48d9-bc34-50b6597c8978-26b.png",
        //                     "contentType" : 2,
        //                     "contentTypeName" : "IMAGE",
        //                     "id" : "160995126640516099512664057967"
        //                 }
        //             }, 
        //             {
        //                 "id" : "160995141471316099514147138325",
        //                 "question" : {
        //                     "content" : "<p>Front view</p>",
        //                     "contentType" : 1,
        //                     "contentTypeName" : "TEXT",
        //                     "id" : "160995126931116099512693113799"
        //                 },
        //                 "answer" : {
        //                     "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/c5f55191-8dcb-4769-849c-642e56df8ec0-26c.png",
        //                     "contentType" : 2,
        //                     "contentTypeName" : "IMAGE",
        //                     "id" : "160995126931116099512693119458"
        //                 }
        //             }
        //         ]
        //     },
        //     "notes" : {
        //         "error" : "",
        //         "success" : ""
        //     },
        //     "createdDate" : 1611130417623.0,
        //     "createdBy" : "",
        //     "updatedDate" : 1611147234310.0,
        //     "updatedBy" : "",
        //     "state" : "",
        //     "author" : "",
        //     "parallel" : [],
        //     "hint" : "",
        //     "comprehension" : [],
        //     "mandatoryAttachments" : {
        //         "audio" : false,
        //         "video" : false,
        //         "image" : false
        //     },

        // }

        // Grouping 

        // content = {
        //     "_id" : "618910222f081330c715ff2d",
        //     "title" : "",
        //     "displayTitle" : "",
        //     "type" : 5,
        //     "typeName" : "ASSESSMENT QUESTION",
        //     "content" : {
        //         "type" : 6,
        //         "typeName" : "GROUPING",
        //         "title" : "<p>Group the pairs as &lsquo;In proportion&rsquo; and &lsquo;Not in proportion&rsquo;.</p>",
        //         "images" : [],
        //         "complexityId" : "5e71f8fe5c3254149568b8a8",
        //         "duration" : 2,
        //         "mark" : 3,
        //         "solutionSteps" : {
        //             "type" : "",
        //             "typeName" : "",
        //             "question" : [],
        //             "steps" : [],
        //             "conclusion" : "",
        //             "summarySolution" : "<ul><li>130 : 208 and 160 : 256</li></ul><p><cw-math data=\"130\\colon208=\\frac{130}{208}=\\frac{5 ×26}{8 ×26}=\\frac{5}{8}.\">130\\colon208=\\frac{130}{208}=\\frac{5 ×26}{8 ×26}=\\frac{5}{8}.</cw-math></p><p>&nbsp;</p><p><cw-math data=\"160\\colon256=\\frac{160}{256}=\\frac{5 ×32}{8 ×32}=\\frac{5}{8}.\">160\\colon256=\\frac{160}{256}=\\frac{5 ×32}{8 ×32}=\\frac{5}{8}.</cw-math></p><p>&nbsp;</p><p>Hence, the ratios 130 : 208 and 160 : 256 are in proportion.</p><p>&nbsp;</p><ul><li>84 : 56 and 129 : 86</li></ul><p><cw-math data=\"84\\colon56=\\frac{84}{56}=\\frac{3 ×28}{2 ×28}=\\frac{3}{2}.\">84\\colon56=\\frac{84}{56}=\\frac{3 ×28}{2 ×28}=\\frac{3}{2}.</cw-math></p><p>&nbsp;</p><p><cw-math data=\"129\\colon86=\\frac{129}{86}=\\frac{3 ×43}{2 ×43}=\\frac{3}{2}.\">129\\colon86=\\frac{129}{86}=\\frac{3 ×43}{2 ×43}=\\frac{3}{2}.</cw-math></p><p>&nbsp;</p><p>Hence, the ratios 84 : 56 and 129 : 86 are in proportion.</p><p>&nbsp;</p><ul><li>51 : 85 and 87 : 145</li></ul><p><cw-math data=\"51\\colon85=\\frac{51}{85}=\\frac{3 ×17}{5 ×17}=\\frac{3}{5}.\">51\\colon85=\\frac{51}{85}=\\frac{3 ×17}{5 ×17}=\\frac{3}{5}.</cw-math></p><p>&nbsp;</p><p><cw-math data=\"87\\colon145=\\frac{87}{145}=\\frac{3 ×29}{5 ×29}=\\frac{3}{5}.\">87\\colon145=\\frac{87}{145}=\\frac{3 ×29}{5 ×29}=\\frac{3}{5}.</cw-math></p><p>&nbsp;</p><p>Hence, the ratios 51 : 85 and 87 : 145 are in proportion.</p><p>&nbsp;</p><ul><li>42 : 63 and 28 : 70</li></ul><p><cw-math data=\"42\\colon63=\\frac{42}{63}=\\frac{2 ×21}{3 ×21}=\\frac{2}{3}\">42\\colon63=\\frac{42}{63}=\\frac{2 ×21}{3 ×21}=\\frac{2}{3}</cw-math></p><p>&nbsp;</p><p><cw-math data=\"28\\colon70=\\frac{28}{70}=\\frac{2 ×14}{5 ×14}=\\frac{2}{5}\">28\\colon70=\\frac{28}{70}=\\frac{2 ×14}{5 ×14}=\\frac{2}{5}</cw-math></p><p>&nbsp;</p><p>Both the ratios are in their lowest form and both are not equal.</p><p>Hence, the ratios 42 :&nbsp; 63 and 28 : 70 are not in proportion.</p><p>&nbsp;</p><ul><li>90 : 216 and 182 : 168</li></ul><p><cw-math data=\"90\\colon216=\\frac{90}{216}=\\frac{5 ×18}{12 ×18}=\\frac{5}{12}.\">90\\colon216=\\frac{90}{216}=\\frac{5 ×18}{12 ×18}=\\frac{5}{12}.</cw-math></p><p>&nbsp;</p><p><cw-math data=\"182\\colon168=\\frac{182}{168}=\\frac{13 ×14}{12 ×14}=\\frac{13}{12}.\">182\\colon168=\\frac{182}{168}=\\frac{13 ×14}{12 ×14}=\\frac{13}{12}.</cw-math></p><p>&nbsp;</p><p>Both the ratios are in their lowest form and both are not equal.</p><p>Hence, the ratios 90 : 216 and 182 : 168 are not in proportion.</p><p>&nbsp;</p><ul><li>55 : 60 and 31 : 155</li></ul><p><cw-math data=\"55\\colon60=\\frac{55}{60}=\\frac{11 ×5}{12 ×5}=\\frac{11}{12}.\">55\\colon60=\\frac{55}{60}=\\frac{11 ×5}{12 ×5}=\\frac{11}{12}.</cw-math></p><p>&nbsp;</p><p><cw-math data=\"31\\colon155=\\frac{31}{155}=\\frac{1 ×31}{5 ×31}=\\frac{1}{5}.\">31\\colon155=\\frac{31}{155}=\\frac{1 ×31}{5 ×31}=\\frac{1}{5}.</cw-math></p><p>&nbsp;</p><p>Both the ratios are in their lowest form and both are not equal.</p><p>Hence, the ratios 55 : 60 and 31 : 155 are not in proportion.</p>"
        //         },
        //         // "options" : [ 
        //         //     {
        //         //         "title" : "<p>In proportion</p>",
        //         //         "id" : "163637238214916363723821493841",
        //         //         "items" : [ 
        //         //             {
        //         //                 "content" : "<p>130 : 208 and 160 : 256</p>",
        //         //                 "id" : "163637240014016363724001402739",
        //         //                 "contentType" : 1,
        //         //                 "contentTypeName" : "TEXT"
        //         //             }, 
        //         //             {
        //         //                 "content" : "<p>84 : 56 and 129 : 86</p>",
        //         //                 "id" : "163637241383216363724138320350",
        //         //                 "contentType" : 1,
        //         //                 "contentTypeName" : "TEXT"
        //         //             }, 
        //         //             {
        //         //                 "content" : "<p>51 : 85 and 87 : 145</p>",
        //         //                 "id" : "163637241662816363724166281260",
        //         //                 "contentType" : 1,
        //         //                 "contentTypeName" : "TEXT"
        //         //             }
        //         //         ]
        //         //     }, 
        //         //     {
        //         //         "title" : "<p>Not in proportion</p>",
        //         //         "id" : "163637241971116363724197110745",
        //         //         "items" : [ 
        //         //             {
        //         //                 "content" : "<p>42 : 63 and 28 : 70</p>",
        //         //                 "id" : "163637244568816363724456883169",
        //         //                 "contentType" : 1,
        //         //                 "contentTypeName" : "TEXT"
        //         //             }, 
        //         //             {
        //         //                 "content" : "<p>90 : 216 and 182 : 168</p>",
        //         //                 "id" : "163637245333116363724533310029",
        //         //                 "contentType" : 1,
        //         //                 "contentTypeName" : "TEXT"
        //         //             }, 
        //         //             {
        //         //                 "content" : "<p>55 : 60 and 31 : 155</p>",
        //         //                 "id" : "163637245569016363724556904986",
        //         //                 "contentType" : 1,
        //         //                 "contentTypeName" : "TEXT"
        //         //             }
        //         //         ]
        //         //     }
        //         // ]
        // "options" : [ 
        //     {
        //         "title" : "<p>Congruent</p>",
        //         "id" : "161134909433716113490943370570",
        //         "items" : [ 
        //             {
        //                 "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/302a758e-7382-41d2-ad95-717a490a24e1-6a%20CheckPoint%20Option-01.png",
        //                 "id" : "161134912161216113491216122387",
        //                 "contentType" : 2,
        //                 "contentTypeName" : "IMAGE"
        //             }, 
        //             {
        //                 "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/b3fda8de-56db-49c3-b1c0-ec91f7f931fb-6b%20CheckPoint%20Option-01.png",
        //                 "id" : "161134912649816113491264985851",
        //                 "contentType" : 2,
        //                 "contentTypeName" : "IMAGE"
        //             }, 
        //             {
        //                 "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/68284786-703e-4132-8bcf-1965052064f1-6c%20CheckPoint%20Option-01.png",
        //                 "id" : "161134913269316113491326933853",
        //                 "contentType" : 2,
        //                 "contentTypeName" : "IMAGE"
        //             }
        //         ]
        //     }, 
        //     {
        //         "title" : "<p>Non-Congruent</p>",
        //         "id" : "161134909595216113490959520820",
        //         "items" : [ 
        //             {
        //                 "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/0bb94f56-4563-41cc-a7ff-ac4e6e153798-6d%20CheckPoint%20Options-01.png",
        //                 "id" : "161134914270916113491427095578",
        //                 "contentType" : 2,
        //                 "contentTypeName" : "IMAGE"
        //             }, 
        //             {
        //                 "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/3fd7784b-d7b8-42b1-9ad0-8d3cc84adb28-6e%20CheckPoint%20Option-01.png",
        //                 "id" : "161134915054516113491505454377",
        //                 "contentType" : 2,
        //                 "contentTypeName" : "IMAGE"
        //             }, 
        //             {
        //                 "content" : "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/435426bd-7c60-45cc-9317-6f4f75139328-6f%20CheckPoint%20Option-01.png",
        //                 "id" : "161134915621916113491562194350",
        //                 "contentType" : 2,
        //                 "contentTypeName" : "IMAGE"
        //             }
        //         ]
        //     }
        // ]
        //     },
        //     "notes" : {
        //         "error" : "",
        //         "success" : ""
        //     },
        //     "createdDate" : 1636372512699.0,
        //     "createdBy" : "",
        //     "updatedDate" : 1636374741019.0,
        //     "updatedBy" : "",
        //     "state" : "",
        //     "author" : "",
        //     "parallel" : [],
        //     "hint" : "",
        //     "comprehension" : [],
        //     "mandatoryAttachments" : {
        //         "audio" : false,
        //         "video" : false,
        //         "image" : false
        //     },

        // }



        let categoryThemeId = this.categoryThemeId

        //console.log(content)

        return (


            !this.state.loading ?
                <div className={this.state.isDesktop ? "assessment-engine" : "assessment-engine-responsive"}>
                    <AssessmentHeader
                        title={this.chapterTitle}
                        categoryThemeId={categoryThemeId}
                        timer={true}
                        time={this.state.remainingTime}
                        delegate={this}
                        ref={(ref) => { this.headerComponent = ref }}
                        isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy}
                    >
                    </AssessmentHeader>
                    {
                        this.state.questions && this.state.questions.length ?
                            <AssessmentPagination
                                questions={this.state.questions}
                                activePage={this.state.index + 1}
                                delegate={this}
                                categoryThemeId={categoryThemeId}
                                ref={(ref) => { this.assessmentPaginationComponent = ref }}
                                isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy}
                            />
                            :
                            <></>
                    }

                    {this.state.questionLoading ?
                        <div className="question-wrapper ml-5 mt-4">
                            {
                                this.state.questions && this.state.questions.length > 0 && content && <div>
                                    <MyAssessmentContext.Provider value={{
                                        showFinishFooter: this.state.showFinishFooter,
                                        startIndex: this.state.index,
                                        isAssessment: this.state.isAssessment,
                                        showFlagActive: this.state.questions[this.state.index].isFlagged ? true : false,
                                        disableNext: this.state.disableNext, showAlphabet: true
                                    }}>
                                        <Question delegate={this} ref={(ref) => { this.questionComponent = ref }}
                                            answer={this.state.questions[this.state.index].answer}
                                            content={content}
                                            stepIndex={this.state.stepIndex}
                                            showHint={this.state.showHint}
                                            showSolvedExamplesModal={this.state.showSolvedExamplesModal}
                                            showInvalidAnswerModal={this.state.showInvalidAnswerModal}
                                            showCorrectIncorrectModal={this.state.showCorrectIncorrectModal}
                                            isAnswerCorrect={this.isCorrect}
                                            categoryThemeId={categoryThemeId}
                                            isFromMyAssessment={true}
                                            isFromMyHomework={this.meta.isFromMyHomework}
                                            isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy}
                                            practiceId={this.meta.practice && this.meta.practice.practiceId ? this.meta.practice.practiceId : ''}
                                            attachments={this.state.questions[this.state.index].attachments ? this.state.questions[this.state.index].attachments : (this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : [])}
                                        ></Question>
                                    </MyAssessmentContext.Provider>
                                </div>
                            }
                        </div>
                        :
                        <></>
                    }

                    {this.state.showFlagPopUp && <FlagPopup close={this.hideFlagPopUp} onPressYes={this.onPressFlagYes} categoryThemeId={categoryThemeId} />}
                    {this.state.showSlowInternetPopup && <CorrectIncorrectAnswerModel delegate={this} showSlowInternetPopup={this.state.showSlowInternetPopup} />}
                    {this.state.showAssessEndPopUp && <AssessmentEndPopup flaggedContent={this.flaggedContents} close={this.hideAssessEndPopUp} delegate={this} time={this.currentTime} categoryThemeId={categoryThemeId} liveTimer={this.state.currentTime}
                        isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy} />}
                    {this.state.showTimeUpPopUp && <AssessmentEndPopup type="TIMEUP_POPUP" onPressTimeUpContinue={this.onPressTimeUpContinue} categoryThemeId={categoryThemeId} isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy} />}
                </div>
                :
                <Loading />
        )
    }

}

export default AssessmentEngine;